import { useEffect } from "react";
import ReactGA from "react-ga4";
import { Divider } from "theme";

import ControlledCalendar from "../../components/Forms/TimeSelectionForm/components/ControlledCalendar.tsx";
import TimeSelectionForm from "../../components/Forms/TimeSelectionForm/TimeSelectionForm.tsx";

const TimeSelection = () => {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.href, title: "TIME_SELECTION_PAGE" });
  }, []);

  return (
    <div>
      <Divider />
      <ControlledCalendar />
      <Divider />
      <TimeSelectionForm />
    </div>
  );
};

export default TimeSelection;
